import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./Navbar.css";
import Logoaspen from "../../media/aspenlogo.svg";
import { NavLink } from "react-router-dom";
import * as bootstrap from "bootstrap";

const Navbar = () => {
  useEffect(() => {
    const navbar = document.querySelector(".navbar-menu");
    const handleScroll = () => {
      if (window.scrollY > 20) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById("mobileOffcanvas");
    const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
    bsOffcanvas?.hide();

    // ✅ Remove remaining backdrop manually (for React context)
    const backdrop = document.querySelector(".offcanvas-backdrop");
    if (backdrop) {
      backdrop.remove();
      document.body.classList.remove(
        "offcanvas-backdrop",
        "show",
        "modal-open"
      );
      document.body.style.overflow = ""; // reset scroll lock
    }
  };

  return (
    <>
      {/* ===========================
          TOPBAR
      ============================ */}
      <header className="navbar-wrapper">
        <div className="container py-3 d-none d-lg-flex flex-column flex-md-row justify-content-between align-items-center">
          <NavLink
            className="navbar-brand d-flex align-items-center mb-3 mb-md-0"
            to="/"
          >
            <img src={Logoaspen} alt="Aspen Logo" className="navbar-logo" />
          </NavLink>

          <div className="navbar-contacts d-flex flex-column flex-md-row gap-4 text-center text-md-start">
            <div className="navbar-contact-item d-flex align-items-center gap-2">
              <div className="navbar-icon-box">
                <i className="bi bi-telephone"></i>
              </div>
              <div>
                <small className="text-muted">CALL US 24/7</small>
                <br />
                <strong>720-412-7990 </strong>
              </div>
            </div>
            <div className="navbar-contact-item d-flex align-items-center gap-2">
              <div className="navbar-icon-box">
                <i className="bi bi-envelope"></i>
              </div>
              <div>
                <small className="text-muted">MAIL FOR SUPPORT</small>
                <br />
                <strong>aspensrbusinesssolutions@gmail.com</strong>
              </div>
            </div>
            <div className="navbar-contact-item d-flex align-items-center gap-2">
              <div className="navbar-icon-box">
                <i className="bi bi-geo-alt"></i>
              </div>
              <div>
                <small className="text-muted">OFFICE ADDRESS</small>
                <br />
                <strong>4340 S Abilene Cir, Aurora CO 80015</strong>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ===========================
          STICKY NAVBAR
      ============================ */}
      <nav className="navbar-menu bg-white border-top border-bottom">
        <div className="container py-3 d-flex justify-content-between align-items-center">
          <ul className="navbar-links nav d-none d-lg-flex">
            {[
              { to: "/", label: "HOME", end: true },
              { to: "/about", label: "ABOUT" },
              { to: "/accounting", label: "ACCOUNTING" },
              { to: "/consulting", label: "CONSULTING" },
              { to: "/grants", label: "GRANTS" },
              { to: "/taxes", label: "TAXES" },
            ].map(({ to, label, end }) => (
              <li className="nav-item" key={to}>
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    `nav-link fw-bold ${isActive ? "active-link" : ""}`
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}

            {/* 🔗 External Blog Link */}
            <li className="nav-item">
              <a
                href="https://aspensraccounting.blogspot.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link fw-bold"
              >
                BLOG
              </a>
            </li>
          </ul>

          <div className="navbar-contact-link d-none d-lg-flex align-items-center">
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `btn btn-outline-primary fw-bold px-4 py-2 rounded-pill ${
                  isActive ? "active-contact-link" : ""
                }`
              }
            >
              CONTACT US
            </NavLink>
          </div>

          {/* MOBILE toggler */}
          <div className="d-flex d-lg-none w-100 justify-content-between align-items-center">
            <NavLink className="navbar-brand" to="/" onClick={closeOffcanvas}>
              <img src={Logoaspen} alt="Aspen Logo" className="navbar-logo" />
            </NavLink>
            <button
              className="btn btn-dark"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mobileOffcanvas"
            >
              <i className="bi bi-list text-white fs-4"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Offcanvas for Mobile */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileOffcanvas"
      >
        <div className="offcanvas-header">
          <NavLink className="navbar-brand" to="/" onClick={closeOffcanvas}>
            <img src={Logoaspen} alt="Aspen Logo" className="navbar-logo" />
          </NavLink>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div className="offcanvas-body d-flex flex-column justify-content-between h-100">
          <ul className="navbar-links nav flex-column gap-3">
            {[
              { to: "/", label: "HOME", end: true },
              { to: "/about", label: "ABOUT" },
              { to: "/accounting", label: "ACCOUNTING" },
              { to: "/consulting", label: "CONSULTING" },
              { to: "/grants", label: "GRANTS" },
              { to: "/taxes", label: "TAXES" },
              {
                to: "https://aspensraccounting.blogspot.com/",
                label: "BLOG",
                external: true,
              },
              { to: "/contact", label: "CONTACT US" },
            ].map(({ to, label, end, external }) => (
              <li className="nav-item" key={to}>
                {external ? (
                  <a
                    href={to}
                    className="nav-link fw-bold"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeOffcanvas}
                  >
                    {label}
                  </a>
                ) : (
                  <NavLink
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                      `nav-link fw-bold ${isActive ? "active-link" : ""}`
                    }
                    onClick={closeOffcanvas}
                  >
                    {label}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>

          {/* Contact Info for Mobile */}
          {/* Contact Info for Mobile */}
          <div className="navbar-contacts navbar-contacts-mobile mt-4">
            {/* First Row: Phone + Address */}
            <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mb-3">
              {/* Phone */}
              <div className="navbar-contact-item d-flex align-items-start gap-2">
                <div className="navbar-icon-box">
                  <i className="bi bi-telephone"></i>
                </div>
                <div>
                  <small className="text-muted">CALL US 24/7</small>
                  <br />
                  <strong>720-412-7990</strong>
                </div>
              </div>

              {/* Address */}
              <div className="navbar-contact-item d-flex align-items-start gap-2">
                <div className="navbar-icon-box">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div>
                  <small className="text-muted">OFFICE ADDRESS</small>
                  <br />
                  <strong>
                    4340 S Abilene Cir,
                    <br /> Aurora CO 80015
                  </strong>
                </div>
              </div>
            </div>

            {/* Second Row: Email */}
            <div className="navbar-contact-item d-flex align-items-start gap-2">
              <div className="navbar-icon-box">
                <i className="bi bi-envelope"></i>
              </div>
              <div>
                <small className="text-muted">MAIL FOR SUPPORT</small>
                <br />
                <strong>aspensrbusinesssolutions@gmail.com</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
